import { action, observable } from "mobx";
import { api, api_adm, apiOperacao } from "../../api";
import { toast } from "react-toastify";
import { toast_error } from "../../utils";

export class _IcmsAliquotaStore {
  obs = observable({
    icms_aliquotas_paginate: [] as any[],
    filter_destino: "" as string,
    filter_origem: "" as string,
    totalRows: 0 as number,
    currentPage: 1 as number,
  })

  @action
  async Load() {
    try {
      let params = {
        filter_origem: "",
        filter_destino: "",
        page: this.obs.currentPage,
        limit: 27
      }

      let resp = await apiOperacao("legislacoes").post(`/legislacoes/icms-aliquotas/busca`, params)

      this.obs.icms_aliquotas_paginate = [];
      this.obs.totalRows = 0

      if (resp.data.itens.length > 0) {
        this.obs.icms_aliquotas_paginate = resp.data.itens
        this.obs.totalRows = resp.data.count
      }

    } catch (ex) {
      toast_error(ex, `Erro ao carregar Icms Aliquotas.`);
    }
  }

  async handleFilter(page: number, filter_origem: string, filter_destino: string) {
    try {
      let params = {
        filter_origem: filter_origem,
        filter_destino: filter_destino,
        page: page,
        limit: 27
      }

      let resp = await apiOperacao("legislacoes").post(`/legislacoes/icms-aliquotas/busca`, params)

      this.obs.icms_aliquotas_paginate = [];
      this.obs.totalRows = 0

      if (resp.data.itens.length > 0) {
        this.obs.icms_aliquotas_paginate = resp.data.itens
        this.obs.totalRows = resp.data.count
      }

    } catch (ex) {
      toast_error(ex, `Erro ao filtrar Icms Aliquotas.`);
    }
  }

  async handleEdit(params: any) {

    try {
      let resp = await api_adm.post(`/api/admin/icms-aliquotas/update`, params);

      if (resp.data.ok) {
        toast.success('Editado com sucesso!', {});
        window.location.reload();
      }
      else {
        toast.warning('Não foi possível editar. Tente novamente mais tarde.', {});
      }
    } catch (ex) {
      toast.error("Erro editando Icms Aliquota!", {});
    }
  }

  async handleDeleteIcms(id: string) {
    try {
      let resp = await api_adm.delete(`/api/admin/icms-aliquotas/${id}`);
      if (resp.data.ok) {
        toast.success('Icms Alíquota excluído', {})
        window.location.reload();
      } else {
        toast.error(`Não foi possível excluir Icms Alíquota`, {})
      }

    } catch (ex) {
      toast.error(`Erro ao excluir Icms Alíquota!`, {});
    }
  }

  async doSaveDuplicaIcms(icms_aliquota) {
    try {
      let resp = await api_adm.post('/api/admin/icms-aliquotas', icms_aliquota);
      if (resp.data.ok) {
        toast.success('Icms Alíquota Duplicado', {});
        window.location.reload();
      } else {
        toast.error(`Não foi possível duplicar Icms Alíquota`, {});
      }
    } catch (ex) {
      toast.error(`Erro ao duplicar Icms Alíquota!`, {});
    }
  }

  async doSaveCreateIcms(icms_aliquota) {
    try {
      let resp = await api_adm.post('/api/admin/icms-aliquotas', icms_aliquota);
      if (resp.data.ok) {
        toast.success('Icms Alíquota Criado', {});
        window.location.reload();
      } else {
        toast.error(`Não foi possível criar Icms Alíquota`, {});
      }
    } catch (ex) {
      toast.error(`Erro ao criar Icms Alíquota!`, {});
    }
  }
}

export const IcmsAliquotaStore = new _IcmsAliquotaStore();